// removed by extract-text-webpack-plugin
module.exports = {"ChartAndDetail":"_1pwxB","Chart":"_3WN4e","Detail":"_23p8K","Donut":"_2JEra","Value":"_1gSOm","Title":"_1btwq"};


//////////////////
// WEBPACK FOOTER
// ./visualizations/visualizations/PieChart.css
// module id = 489
// module chunks = 3 4 5